import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as loginState from '../reducers/login.reducer';
import * as fromAuthReducer from '../auth.reducer';
//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion
//#region Register SUB STATE
export const getLoginState = createSelector(getAuthState, state => state[loginState.loginFeatureKey]);
//#endregion
//#region REGISTRATION
export const getLoginIsLoading = createSelector(getLoginState, loginState.getIsLoginLoading);
export const getLoginRequest = createSelector(getLoginState, loginState.getLoginRequest);
export const getLoginSuccess = createSelector(getLoginState, loginState.getLoginSuccess);
export const getLoginFailure = createSelector(getLoginState, loginState.getLoginFailure);
//#endregion
